import type { Channel, ProductType } from "@/api_client";

import { getEcommerceEntry } from "./data/ecommerce";
import insuranceInfo from "./data/insuranceInfo";
import processInfo from "./data/processInfo";
import productInfo from "./data/productInfo";
import type { InsuranceInfo, ProductPageImpression } from "./types/types";

export const createProductPageImpression = (
  contextId: string,
  productType: ProductType,
  channel: Channel,
): ProductPageImpression => {
  const event: ProductPageImpression = {
    event: "Product Page Impression",
    productInfo: productInfo.getProductInfoEntryPage(productType, channel),
    processInfo: processInfo.getProcessInfo("productpage"),
    insuranceInfo: [
      insuranceInfo.insuranceInfoUnknown(contextId),
    ] as InsuranceInfo[],
    ecommerce: getEcommerceEntry(productType, channel),
  };

  return event;
};
